
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A2001D","d":"M0 0h513v172H0z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M0 172h513v172H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M381.4 251.5l-110.7-13.8-110.8 13.8V85.4h221.5z"}}),_c('circle',{attrs:{"fill":"#0052B4","cx":"270.7","cy":"182.3","r":"55.4"}}),_c('circle',{attrs:{"fill":"#A2001D","cx":"270.7","cy":"182.3","r":"27.7"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M229.1 113.1h83.1l-41.5 41.5z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M256.8 140.8h27.7v83h-27.7z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M314.9 215.5h-88.5l-66.5 36h221.5z"}})])
          )
        }
      }
    